<template>
  <Transition name="fade">
    <div
      v-if="loaderStore.isLoading"
      class="global-loader"
    >
      <div class="loader-content">
        <div class="spinner" />
        <p class="message">
          {{ loaderStore.loadingMessage }}
        </p>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useLoaderStore } from '@/stores/loader'

const loaderStore = useLoaderStore()
</script>

<style scoped>
.global-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--shadow-color);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader-content {
  background: var(--bg-dark-secondary);
  padding: 24px;
  border-radius: 8px;
  text-align: center;
  min-width: 200px;
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto 16px;
  border: 3px solid var(--tab-button-inactive);
  border-top-color: var(--colour-green-button);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.message {
  color: var(--colour-icons);
  margin: 0;
  font-size: 14px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style> 